export enum CheckoutStepIds {
  CustomerInfo = 'customer-info',
  PaymentMethod = 'payment-method',
  CreditCardDetails = 'credit-card-details',
  CreditCardInstallments = 'credit-card-installments',
  DataConfirmation = 'data-confirmation',
  PixBankSlip = 'pix-bank-slip',
  PaymentStatus = 'payment-status',
}
